import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../formly/ga-formly.service';
import { FormattingService } from '../../services/formatting.service';
import { IReportAction } from '../report-data.service';
import { GaMessageService } from '../../message/ga-message.service';
import { util } from '../../util';
import { ReportActionsSubmitComponent } from './report-actions-submit.component';

@Component({
  selector: 'report-actions',
  template: `
    <formly [form]="form" [fields]="fields" [model]="model" class="report-actions"></formly> 
  `,
  styleUrls: ['./report-actions.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportActionsComponent implements OnInit, OnChanges {
  @Input() public actions: IReportAction[];
  @Input() public busy: boolean;
  @Input() public disabled: boolean;
  @Output() public onAction: EventEmitter<IReportAction> = new EventEmitter<IReportAction>();

  public form: UntypedFormGroup = new UntypedFormGroup({});
  public fields: IExtraFieldConfigurationObject[];
  public model: { selectedAction?: IReportAction }  = {};

  private actionSubmitField: IExtraFieldConfigurationObject;
  private applyMessage: Noty;

  constructor(
    private formlyService: GaFormlyService,
    private formattingService: FormattingService,
    private messageService: GaMessageService
  ) {
    /**/
  }

  public ngOnInit(): void {
    /**/
  }

  public ngOnChanges(changes: SimpleChanges): void {
    // initiate fields here because ngOnChanges triggered first before ngOnInit
    if (!this.fields) {
      this.fields = this.createFields();
    }

    if (changes.busy) {
      this.actionSubmitField.templateOptions.inputs.busy = changes.busy?.currentValue;
    }

    if (changes.disabled) {
      this.actionSubmitField.templateOptions.inputs.reportActionDisabled = changes.disabled?.currentValue;
    }

    if (util.notNullOrUndefinedOrEmpty(changes.apply?.currentValue)) {
      this.showMessageApplyAction(changes.apply.currentValue);
    }
  }

  private showMessageApplyAction(apply: boolean): void {
    if (apply) {
      this.applyMessage = this.messageService.showStatusMessage(`Executing the action ${this.model?.selectedAction?.name} ...`);
    } else {
      this.messageService.closeMessage(this.applyMessage);
    }
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aTemplate('<h3 class="my-actions-title margin-top-sm">Actions</h3>')
        .withWrapperClass('col')
        .build(),
      this.formlyService.aSelect('selectedAction', 'Action')
        .withFormat(this.formattingService.formatName)
        .withValueClass('col')
        .withLabelClass('d-none')
        .withOptions(this.actions)
        .withWrapperClass('col-auto report-actions-select')
        .onChange((selectedAction: IReportAction) => {
          this.actionSubmitField.templateOptions.inputs.selectedAction = selectedAction;
        })
        .build(),
      this.actionSubmitField = this.formlyService.aCustom()
        .withComponent(ReportActionsSubmitComponent)
        .withExtraOptions({
          templateOptions: {
            inputs: {
              busy: this.busy,
              reportActionDisabled: this.disabled,
              selectedAction: this.model?.selectedAction
            },
            outputs: {
              onAction: () => this.onAction.emit(this.model?.selectedAction)
            }
          }
        })
        .withLabelClass('d-none')
        .withWrapperClass('col')
        .build()
    ];
  }
}